export const stdColorLight = "grey lighten-1";
export const stdColorDark = "grey darken-1";
export const stdColorMasterDetail = "blue darken-2";
export const stdColorSelectedRow = "#BBDEFB"; //blue lighten-4: must use Hex-code for HTML-Elements
export const colorSystemBarOn = "blue darken-2";
export const colorSystemBarOff = "#ffffff";

export default class MyColors {
  static get stdColorLight() {
    return stdColorLight;
	}

  static get stdColorDark() {
    return stdColorDark;
  }
  
  static get stdColorMasterDetail() {
    return stdColorMasterDetail;
  }
  
  static get stdColorSelectedRow() {
    return stdColorSelectedRow;
	}
	
  static get colorSystemBarOn() {
    return colorSystemBarOn;
	}
	
  static get colorSystemBarOff() {
    return colorSystemBarOff;
  }
}
